
import styles from "../LandingV2.module.scss";

export const JoinWhatsapp = () => {
  return (
    <div className="container">
      <div className={styles.whatsapp}>
        <h3>Join us on Whatsapp</h3>
        <p>
          Opt in to receive regular promotional updates with many theme based
          competitions including unlimited options to save on your groceries.
        </p>
        <span
          role="button"
          onClick={() => window.open("https://wa.me/4917670009491")}
        >
          Click here
        </span>
        {window.innerWidth > 576 && <img loading="lazy" decoding="async"
          src="https://desi-fresh.b-cdn.net/misc/whatsapp.png"
          alt="whatsapp"
        />}
      </div>
    </div>
  );
};